import axios from 'axios'
import store from '../store'

export default function postLogin (username, password) {
  return axios({
    method: 'post',
    url: 'login',
    baseURL: store.state.env.api_base,
    data: {
      username: username,
      password: password,
      grant_type: 'password',
      client_secret: store.state.env.api_secret,
      client_id: store.state.env.api_id
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/postLogin.js